module.exports = __webpack_public_path__ + "img/zh_cn_bubble.ce732c7.png";